import styled from "styled-components";
import css from "@styled-system/css";
import { Box, Button, CircularLoader } from "@bca/ui-library";
import { ReactElement } from "react";

const ShowVehiclesContainer = styled(Box)`
  ${css({
    border: "normalBorder",
    boxShadow: "default",
  })}
  mix-blend-mode: normal;
  box-sizing: border-box;
`;

interface FooterProps {
  onShowVehicles: () => void;
  shouldShowVrmQueryWarning: boolean;
  onClearAll: () => void;
  isClearAllDisabled: boolean;
  totalResults: number;
}

const Footer: React.FunctionComponent<FooterProps> = ({
  onShowVehicles,
  shouldShowVrmQueryWarning,
  onClearAll,
  isClearAllDisabled,
  totalResults,
}) => {
  const getTotalVehiclesLabel = () => {
    let totalVehiclesLabel: string | number | ReactElement = "All";
    if (!isClearAllDisabled) {
      totalResults === undefined || isNaN(totalResults)
        ? (totalVehiclesLabel = (
            <CircularLoader title="TotalRESULTS" width={20} height={20} />
          ))
        : (totalVehiclesLabel = totalResults);
    }
    return totalVehiclesLabel;
  };

  return (
    <ShowVehiclesContainer
      px={5}
      py={5}
      width="100%"
      backgroundColor="primary-white"
      display="flex"
    >
      {!isClearAllDisabled && (
        <Box flex="1" mr="10px">
          <Button
            variant="secondary"
            onClick={onClearAll}
            width="100%"
            icon="trash"
            iconWidth={12}
            iconHeight={14}
            fontSize="body-small"
            px={5}
          >
            Clear all
          </Button>
        </Box>
      )}
      <Box flex={1}>
        <Button
          width="100%"
          onClick={onShowVehicles}
          disabled={shouldShowVrmQueryWarning}
          fontSize="body-small"
          px={5}
        >
          See {getTotalVehiclesLabel()} Vehicles
        </Button>
      </Box>
    </ShowVehiclesContainer>
  );
};

export default Footer;
